module.exports = __webpack_public_path__ + "static/poster4-ca30c63cf6d856904a591932e76e5b5d.jpg";